import React, { useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import Branding_1 from '../../../assets/images/home_page_3/branding/01.png'
import Branding_2 from '../../../assets/images/home_page_3/branding/02.png'
import Branding_3 from '../../../assets/images/home_page_3/branding/03.png'
import Branding_4 from '../../../assets/images/home_page_3/branding/04.png'



const Branding = () => {
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);

    const mainSliderSettings = {
        asNavFor: nav2,
        ref: (slider) => setNav1(slider),
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        fade: true,
        slidesToScroll: 1,
        arrows: false,
    };

    // Custom Previous Arrow
const PrevArrow = (props) => {
    const { className, onClick } = props;
    return (
        <button type="button" className={`${className} slick-prev`} onClick={onClick}>
            <i className="flaticon-left-arrow-1" />
        </button>
    );
};

// Custom Next Arrow
const NextArrow = (props) => {
    const { className, onClick } = props;
    return (
        <button type="button" className={`${className} slick-next`} onClick={onClick}>
            <i className="flaticon-right-arrow-1" />
        </button>
    );
};

    const thumbSliderSettings = {
        asNavFor: nav1,
        ref: (slider) => setNav2(slider),
        slidesToShow: 2.3,
        margin: 10,
        slidesToScroll: 1,
        focusOnSelect: true,
        arrows: true,
        centerMode: true,
        infinite: true,
        nav: true,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
    };

    const [quantity, setQuantity] = useState(1); // State for quantity

    const handleQuantityChange = (action) => {
        if (action === "add" && quantity < 10) {
            setQuantity(quantity + 1);
        } else if (action === "minus" && quantity > 0) {
            setQuantity(quantity - 1);
        }
    };


    return (
        <section id="branding" className="branding-main-block">
            <div className="container">
                <div className="row g-0">
                    <div className="col-lg-6">
                        <div className="branding-block">
                            <div className="section-sub-title">Shoes &amp; Pant’s</div>
                            <h4 className="section-title-three">
                                Best Branding <span>Shoes</span>
                            </h4>
                            <ul className="branding-price">
                                <li className="discount-price">
                                    <s>$98.00</s>
                                </li>
                                <li className="price">$83.00</li>
                            </ul>
                            <p>
                                when our power of choice is untrammelled and when nothing prevents
                                our being able to do what we like best, every pleasure is to be
                                welcomed and every pain avoided. But in certain circumstances .
                            </p>
                            <Slider className="slider branding-nav" {...thumbSliderSettings}>
                                <div className="branding-nav-img">
                                    <img
                                        src={Branding_1}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                                <div className="branding-nav-img">
                                    <img
                                        src={Branding_2}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                                <div className="branding-nav-img">
                                    <img
                                        src={Branding_3}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                                <div className="branding-nav-img">
                                    <img
                                        src={Branding_1}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                            </Slider>
                            <div className="branding-input-button">
                                <div className="qty-input-three">
                                    <button
                                        className="qty-count qty-count--add"
                                        type="button"
                                        onClick={() => handleQuantityChange("add")}
                                    >
                                        +
                                    </button>
                                    <input
                                        className="product-qty"
                                        type="number"
                                        name="product-qty"
                                        min={0}
                                        max={10}
                                        value={quantity} // Controlled input
                                        readOnly // Prevent manual typing (optional)
                                    />
                                    <button
                                        className="qty-count qty-count--minus"
                                        type="button"
                                        onClick={() => handleQuantityChange("minus")}
                                    >
                                        -
                                    </button>
                                </div>
                                <div className="branding-cart-btn">
                                    <Link to="#" className="btn btn-primary-three">
                                        <i className="flaticon-shopping-bag-1" />
                                        Add To Cart
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <Slider className="slider branding-for" {...mainSliderSettings}>
                            <div className="branding-for-img">
                                <img
                                    src={Branding_4}
                                    className="img-fluid"
                                    alt=""
                                />
                            </div>
                            <div className="branding-for-img">
                                <img
                                    src={Branding_4}
                                    className="img-fluid"
                                    alt=""
                                />
                            </div>
                            <div className="branding-for-img">
                                <img
                                    src={Branding_4}
                                    className="img-fluid"
                                    alt=""
                                />
                            </div>
                            <div className="branding-for-img">
                                <img
                                    src={Branding_4}
                                    className="img-fluid"
                                    alt=""
                                />
                            </div>
                        </Slider>
                    </div>
                </div>
            </div>
        </section>

    );
};

export default Branding;
